import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Name-Arcane/src/app/directory/DirectoryClient.tsx");
